export default {
  placeholder: 'Anna ravintolan nimi',
  labels: {
    cant_find_place: 'Etkö löydä paikkaa listalta?',
    reset_categories: 'Nollaa paikkakategoriat',
  },
};
